import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M19 13V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V13C5 12.45 4.55 12 4 12C3.45 12 3 12.45 3 13V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13ZM13 12.67L14.88 10.79C15.27 10.4 15.9 10.4 16.29 10.79C16.68 11.18 16.68 11.81 16.29 12.2L12.7 15.79C12.31 16.18 11.68 16.18 11.29 15.79L7.7 12.2C7.31 11.81 7.31 11.18 7.7 10.79C8.09 10.4 8.72 10.4 9.11 10.79L11 12.67V4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4V12.67Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.06506 2.50006C8.06506 2.18802 7.8121 1.93506 7.50006 1.93506C7.18802 1.93506 6.93506 2.18802 6.93506 2.50006V8.63603L4.89957 6.60054C4.67893 6.3799 4.32119 6.3799 4.10054 6.60054C3.8799 6.82119 3.8799 7.17893 4.10054 7.39957L7.10054 10.3996C7.2065 10.5055 7.35021 10.5651 7.50006 10.5651C7.64991 10.5651 7.79362 10.5055 7.89957 10.3996L10.8996 7.39957C11.1202 7.17893 11.1202 6.82119 10.8996 6.60054C10.6789 6.3799 10.3212 6.3799 10.1005 6.60054L8.06506 8.63603V2.50006ZM3.06506 9.50006C3.06506 9.18802 2.8121 8.93506 2.50006 8.93506C2.18802 8.93506 1.93506 9.18802 1.93506 9.50006V12.5001C1.93506 13.3644 2.63573 14.0651 3.50006 14.0651H11.5001C12.3644 14.0651 13.0651 13.3644 13.0651 12.5001V9.50006C13.0651 9.18802 12.8121 8.93506 12.5001 8.93506C12.188 8.93506 11.9351 9.18802 11.9351 9.50006V12.5001C11.9351 12.7403 11.7403 12.9351 11.5001 12.9351H3.50006C3.25981 12.9351 3.06506 12.7403 3.06506 12.5001V9.50006Z"
  />
);

export const DownloadIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Download" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
